import { render } from "./OapAccountNavigation.vue?vue&type=template&id=15dab035"
import script from "./OapAccountNavigation.vue?vue&type=script&lang=js"
export * from "./OapAccountNavigation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__